import { render } from "./ProductMostPurchased.vue?vue&type=template&id=732f0ef3&scoped=true"
import script from "./ProductMostPurchased.vue?vue&type=script&lang=js"
export * from "./ProductMostPurchased.vue?vue&type=script&lang=js"

import "./ProductMostPurchased.vue?vue&type=style&index=0&id=732f0ef3&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732f0ef3"]])

export default __exports__